export const FILE_UPLOADING_ACCEPT_FOR = {
    PDF: ["application/pdf", ".pdf"],
    IMAGE: ["image/jpeg", "image/png", "image/bmp", ".bmp", ".jpeg", ".jpg", ".pdf", ".png"],
    DOCUMENT: [
        "application/pdf",
        "application/rtf",
        "application/vnd.oasis.opendocument.presentation",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.text",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/x-cfb",
        ".odt",
        ".doc",
        ".docx",
        ".odp",
        ".ppt",
        ".pptx",
        ".rtf",
        ".ods",
        ".xls",
        ".xlsx"
    ].join(", "),
    DOCUMENT_AND_IMAGE: [
        "application/pdf",
        "application/rtf",
        "application/vnd.oasis.opendocument.presentation",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/vnd.oasis.opendocument.text",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/x-cfb",
        "image/bmp",
        "image/jpeg",
        "image/png",
        ".bmp",
        ".jpeg",
        ".jpg",
        ".pdf",
        ".png",
        ".odt",
        ".doc",
        ".docx",
        ".odp",
        ".ppt",
        ".pptx",
        ".rtf",
        ".ods",
        ".xls",
        ".xlsx"
    ].join(", ")
}
